/* ,
 * @file countryList.js
 * @author liushengxgi
 * @date 2020-07-13 11:03:19
 * ----
 * @last Modified by liushengxgi
 * @last Modified time 2020-07-13 11:03:24
 */
// 国家列表信息

export const countryList = [
    'ALB',
    'DZA',
    'AFG',
    'ARG',
    'ARE',
    'ABW',
    'OMN',
    'AZE',
    'EGY',
    'ETH',
    'IRL',
    'EST',
    'AND',
    'AGO',
    'AIA',
    'ATG',
    'AUT',
    'ALA',
    'AUS',
    'MAC',
    'BRB',
    'PNG',
    'BHS',
    'PAK',
    'PRY',
    'PSE',
    'BHR',
    'PAN',
    'BRA',
    'BLR',
    'BMU',
    'BGR',
    'MNP',
    'BEN',
    'BEL',
    'ISL',
    'PRI',
    'BIH',
    'POL',
    'BOL',
    'BLZ',
    'BWA',
    'BTN',
    'BFA',
    'BDI',
    'BVT',
    'PRK',
    'GNQ',
    'DNK',
    'DEU',
    'TLS',
    'TGO',
    'DOM',
    'DMA',
    'RUS',
    'ECU',
    'ERI',
    'FRA',
    'FRO',
    'PYF',
    'GUF',
    'ATF',
    'MAF',
    'VAT',
    'PHL',
    'FJI',
    'FIN',
    'CPV',
    'GMB',
    'COG',
    'COD',
    'COL',
    'CRI',
    'GRD',
    'GRL',
    'GEO',
    'GGY',
    'CUB',
    'GLP',
    'GUM',
    'GUY',
    'KAZ',
    'HTI',
    'KOR',
    'NLD',
    'BES',
    'HMD',
    'MNE',
    'HND',
    'KIR',
    'DJI',
    'KGZ',
    'GIN',
    'GNB',
    'CAN',
    'GHA',
    'GAB',
    'KHM',
    'CZE',
    'ZWE',
    'CMR',
    'QAT',
    'CYM',
    'CCK',
    'COM',
    'CIV',
    'KWT',
    'HRV',
    'KEN',
    'COK',
    'LVA',
    'LSO',
    'LAO',
    'LBN',
    'LTU',
    'LBR',
    'LBY',
    'LIE',
    'REU',
    'LUX',
    'RWA',
    'ROU',
    'MDG',
    'IMN',
    'MDV',
    'FLK',
    'MLT',
    'MWI',
    'MYS',
    'MLI',
    'MKD',
    'MHL',
    'MTQ',
    'MYT',
    'MUS',
    'MRT',
    'USA',
    'UMI',
    'ASM',
    'VIR',
    'MNG',
    'MSR',
    'BGD',
    'PER',
    'FSM',
    'MMR',
    'MDA',
    'MAR',
    'MCO',
    'MOZ',
    'MEX',
    'NAM',
    'ZAF',
    'ATA',
    'SGS',
    'SSD',
    'NRU',
    'NPL',
    'NIC',
    'NER',
    'NGA',
    'NIU',
    'NOR',
    'NFK',
    'PLW',
    'PCN',
    'PRT',
    'JPN',
    'SWE',
    'CHE',
    'SLV',
    'WSM',
    'SRB',
    'SLE',
    'SEN',
    'CYP',
    'SYC',
    'SAU',
    'BLM',
    'CXR',
    'STP',
    'SHN',
    'KNA',
    'LCA',
    'SMR',
    'SPM',
    'VCT',
    'LKA',
    'SVK',
    'SVN',
    'SJM',
    'SWZ',
    'SDN',
    'SUR',
    'SLB',
    'SOM',
    'TJK',
    'THA',
    'TZA',
    'TON',
    'TCA',
    'TTO',
    'TUN',
    'TUV',
    'TUR',
    'TKM',
    'TKL',
    'WLF',
    'VUT',
    'GTM',
    'VEN',
    'BRN',
    'UGA',
    'UKR',
    'URY',
    'UZB',
    'ESP',
    'ESH',
    'GRC',
    'HKG',
    'SGP',
    'NCL',
    'NZL',
    'HUN',
    'SYR',
    'JAM',
    'ARM',
    'YEM',
    'IRQ',
    'IRN',
    'ISR',
    'ITA',
    'IND',
    'IDN',
    'GBR',
    'VGB',
    'IOT',
    'JOR',
    'VNM',
    'ZMB',
    'JEY',
    'TCD',
    'GIB',
    'CHL',
    'CAF',
    'CHN',
    'TWN'
];
